import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateModuleByIdStart } from "../../Store/Slices/formSlice";

const QuickCreateModal = ({
  isOpen,
  onClose,
  getCreateUpdateListByID,
  handleSubmit,
  id,
}) => {
  const [storedData, setStoredData] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isOpen && getCreateUpdateListByID?.modules?.[0]) {
      setStoredData({ ...getCreateUpdateListByID.modules[0] });
    }
  }, [isOpen, getCreateUpdateListByID]);

  const handleCheckboxChange = (fieldId, isChecked) => {
    setStoredData((prevState) => {
      const updatedSections = prevState?.fields?.sections?.map((section) => ({
        ...section,
        dropped_list: Object.fromEntries(
          Object.entries(section?.dropped_list || {}).map(([area, fields]) => [
            area,
            fields.map((field) => {
              if (field.id === fieldId) {
                return {
                  ...field,
                  quick_list: isChecked,
                };
              }
              return field;
            }),
          ])
        ),
      }));
      return {
        ...prevState,
        fields: { ...prevState.fields, sections: updatedSections },
      };
    });
  };

  const moduleSave = async () => {
    try {
      if (id && storedData) {
        const updatedModule = {
          ...storedData,
        };
        dispatch(
          updateModuleByIdStart({
            id,
            payload: updatedModule,
          })
        );
      }
      handleSubmit();
    } catch (error) {
      console.error("Error while saving module:", error);
    }
  };

  return (
    <div
      className={`modal fade ${isOpen ? "show d-block" : ""}`}
      id="quickCreateModal"
      tabIndex="-1"
      aria-labelledby="quickCreateModalLabel"
      aria-hidden={!isOpen}
    >
      <div
        className="modal-dialog modal-sm custom-modal-size"
        role="document"
        style={{ maxWidth: "25%" }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="quickCreateModalLabel">
              Create {storedData?.name}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          <div
            className="modal-body"
            style={{ maxHeight: "calc(100vh - 200px)", overflowY: "auto" }}
          >
            <main className="col-lg-12">
              {storedData?.fields?.sections?.map((section, sectionIndex) => (
                <div className="row mb-1" key={sectionIndex}>
                  <h6 className="sec-header pb-2 pt-2 col-12">
                    {section.section_name}
                  </h6>
                  {section?.dropped_list &&
                    Object.entries(section?.dropped_list || {}).map(
                      ([key, value], index) =>
                        value?.length > 0 && (
                          <div key={index} className="col-md-12">
                            {value.map((field) => {
                              const fieldLabel =
                                field.extra_fields?.field_label || field.id;

                              return (
                                <div
                                  key={field.id}
                                  className="form-group w-100"
                                >
                                  <div
                                    className="border p-1 mb-2 rounded shadow-sm bg-light w-100 reduced-container"
                                    style={{
                                      height: "40px",
                                    }}
                                  >
                                    <div
                                      className="d-flex align-items-center justify-content-between w-100"
                                      style={{
                                        gap: "10px",
                                      }}
                                    >
                                      <div
                                        className="d-flex align-items-center"
                                        style={{
                                          gap: "10px",
                                          paddingLeft: "5px",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          checked={field.quick_list === true}
                                          onChange={(e) =>
                                            handleCheckboxChange(
                                              field.id,
                                              e.target.checked
                                            )
                                          }
                                        />

                                        <div className="field-label mt-1">
                                          {field.extra_fields?.field_label}
                                        </div>
                                      </div>

                                      <div
                                        className="col-auto"
                                        style={{
                                          paddingLeft: "5px",
                                          marginLeft: "auto",
                                        }}
                                      >
                                        <label className="ms-2">
                                          {field.label}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )
                    )}
                </div>
              ))}
            </main>
          </div>
          <div className="modal-footer py-2">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={moduleSave}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickCreateModal;
